import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

export function handleSessionLogout() {
  datadogRum.clearUser();
  datadogRum.clearGlobalContext();
  datadogLogs.clearGlobalContext();
  datadogRum.stopSession();
}

export function logErrorToDatadog(error: any) {
  try {
    const context = {
      route: window.location.pathname,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString(),
    };

    // ✅ 1. RUM Error Tracking (for session replay + frontend errors)
    datadogRum.addError(error, context);

    // ✅ 2. Logs (for backend-style observability)
    datadogLogs.logger.error(
      error?.message || 'Unknown error',
      {
        ...context,
        stack: error?.stack,
        name: error?.name,
      }
    );

    // Optional: attach severity / tags
    datadogLogs.logger.error('critical-ui-error', {
      ...context,
      level: 'critical',
    });

  } catch (e) {
    console.error('Datadog logging failed', e);
  }
}
